exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GBETKxr8JhFDOjvMYMWMN .fDRoG1saYzEg4FxykjDZ8{margin:0 -10px}.GBETKxr8JhFDOjvMYMWMN .fDRoG1saYzEg4FxykjDZ8:before,.GBETKxr8JhFDOjvMYMWMN .fDRoG1saYzEg4FxykjDZ8:after{display:table;content:\"\";clear:both}._2oUy5S8r0MbZXrDPnXSwkP{height:150px;width:150px;margin:10px;display:block;float:left;text-align:center}._2oUy5S8r0MbZXrDPnXSwkP ._2WevwUBoZcmY2IDSmpCw9Q{color:#686868}._2oUy5S8r0MbZXrDPnXSwkP p{margin:15px 0}\n", ""]);

// Exports
exports.locals = {
	"Icons": "GBETKxr8JhFDOjvMYMWMN",
	"grid": "fDRoG1saYzEg4FxykjDZ8",
	"GridItem": "_2oUy5S8r0MbZXrDPnXSwkP",
	"icon": "_2WevwUBoZcmY2IDSmpCw9Q"
};